import {Animation, AnimationController} from '@ionic/angular/standalone';

export const customPageTransition = (baseEl: HTMLElement, opts?: any): Animation => {
  const animationCtrl = new AnimationController();
  const DURATION = 300;


  const enteringPage = opts.enteringEl;
  const leavingPage = opts.leavingEl;
  try {
    const rootAnimation = animationCtrl
      .create()
      .addElement(enteringPage)
      .duration(DURATION)
      .easing('ease-in')
      .fromTo('opacity', '0', '1')
      // .fromTo('transform', 'translateX(-98vw)', 'translateX(0vw)');
    if (opts.direction === 'forward') {
      return animationCtrl
        .create()
        .addElement(enteringPage)
        .duration(DURATION)
        .easing('ease-in')
        .fromTo('opacity', '0', '1')
        // .fromTo('transform', 'translateX(90vw)', 'translateY(0vw)');
    } else {
      const leavingAnimation = animationCtrl
        .create()
        .addElement(leavingPage)
        .duration(DURATION)
        .iterations(1)
        .onFinish((currentStep: number) => {
          if(currentStep === 1 && leavingAnimation.elements?.length > 0) {
            leavingAnimation.elements[0].style.setProperty('display', 'none');
          }
        })
        .easing('ease-out')
        // .fromTo('transform', 'translateX(0vw)', 'translateX(130px)')
        .fromTo('opacity', '1', '0');

      return animationCtrl.create().addAnimation([rootAnimation, leavingAnimation])
    }
  } catch (e) {
    return animationCtrl.create();
  }
}
